import DOMPurify from 'dompurify';
import { normalizeTiptapHtml } from '@/lib/richtext/normalizeTiptapHtml';

const PURIFY_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'b', 'em', 'i', 'u',
    'h1', 'h2', 'h3', 'h4',
    'ul', 'ol', 'li',
    'a', 'img', 'iframe',
    'blockquote', 'pre', 'code',
  ],
  ALLOWED_ATTR: [
    'href', 'target', 'rel',
    'src', 'alt', 'class',
    'width', 'height', 'style', 'loading',
  ],
  ADD_ATTR: ['target'],
};

function isSafeIframeSrc(src: string | null): boolean {
  if (!src) return false;
  return /^(https?:\/\/|\/)/i.test(src.trim());
}

export function sanitizeRichTextHtml(input: string, options?: { normalize?: boolean }): string {
  if (!input) return '';

  const source = options?.normalize === false ? input : normalizeTiptapHtml(input);
  if (!source) return '';

  const clean = DOMPurify.sanitize(source, PURIFY_CONFIG) as string;
  if (!clean) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${clean}</div>`, 'text/html');
  const root = doc.body.firstElementChild as HTMLElement | null;
  if (!root) return '';

  root.querySelectorAll('a[target="_blank"]').forEach((link) => {
    link.setAttribute('rel', 'noopener noreferrer');
  });

  root.querySelectorAll('iframe').forEach((iframe) => {
    if (!isSafeIframeSrc(iframe.getAttribute('src'))) {
      iframe.remove();
      return;
    }

    const loading = iframe.getAttribute('loading');
    if (loading && loading !== 'lazy' && loading !== 'eager') {
      iframe.removeAttribute('loading');
    }
  });

  return root.innerHTML.trim();
}
